import { useTranslation } from 'react-i18next'

import { Offer } from '@wwt/entities/search-response'

import { Button, ButtonProps } from '@/shared/ui/Button.tsx'

import { useCancel } from '../model/useCancel.ts'

interface CancelButtonProps extends ButtonProps {
	offer: Offer | null
}

export const CancelButton = ({ offer, ...props }: CancelButtonProps) => {
	const { t } = useTranslation('room-page')

	const { onSubmit, isDisabled } = useCancel(offer)

	return (
		<Button
			data-wwt-id="room-offer__cancel-button--unique"
			variant="secondary"
			size="lg"
			onClick={onSubmit}
			disabled={isDisabled}
			{...props}
		>
			{t('cancel')}
		</Button>
	)
}
